export default "/images/4442d5666f170cefaf78ac1d718db9a8.avif";